import { Tooltip } from 'antd';
import React from 'react';
import useFormatMessage from 'hooks/useFormatMessage';
import messages from './messages';

export const getDimensionLabel = ({ $t, dimension, name }) => {
  if (name && messages[name]) {
    return $t(messages[name]);
  } if (dimension && messages[dimension]) {
    return $t(messages[dimension]);
  }

  return name || dimension;
};

export const getDimensionDescription = ({ $t, dimension, name }) => {
  if (name && messages[`${name}Description`]) {
    return $t(messages[`${name}Description`]);
  } if (dimension && messages[`${dimension}Description`]) {
    return $t(messages[`${dimension}Description`]);
  }

  return null;
};

export const DimensionDescription = ({ dimension, name, description }) => {
  const $t = useFormatMessage();
  let descriptionText = null;

  if (description) {
    descriptionText = description;
  } else {
    descriptionText = getDimensionDescription({ $t, dimension, name });
  }

  return descriptionText;
};

const DimensionLabel = ({ dimension, name, label, description, showTooltip, lineBreaks = true }) => {
  const $t = useFormatMessage();
  let labelText = null;

  if (label) {
    if (lineBreaks) {
      labelText = label.replaceAll('\n', '<br/>');
    } else {
      labelText = label;
    }
  } else {
    labelText = getDimensionLabel({ $t, dimension, name });
  }

  labelText = <span dangerouslySetInnerHTML={{ __html: labelText }} />;

  return showTooltip ? (
    <Tooltip title={<DimensionDescription dimension={dimension} name={name} description={description} />}>
      {labelText}
    </Tooltip>
  ) : (
    labelText
  );
};

export default DimensionLabel;
